import {
  CheckCircle2, HelpCircle, XCircle, FileQuestion, ArrowDownLeft, PenLine,
} from 'lucide-react';

// The four delivery states, plus inbound and hand-sent, rendered so they can NEVER be
// mistaken for one another.
//
// NOT BY COLOUR ALONE. Each state carries its own ICON and its own WORD. A user who is
// colour-blind, or reading a printed page, or glancing at a dense list, must still be able
// to tell "we know this arrived" from "we have no idea whether this arrived". That
// distinction is the whole reason Job A existed: the Hub spent months rendering 730
// unverified sends as confirmed deliveries, and 86 known failures among them.
export const DELIVERY = {
  confirmed: {
    label: 'Delivered',
    icon: CheckCircle2,
    cls: 'text-hg-green border-hg-green/50 bg-hg-green/10',
    title: 'Confirmed by the provider: finished_at is set and stats.sent is greater than 0.',
  },
  dispatched_unverified: {
    label: 'Dispatched · unverified',
    icon: HelpCircle,
    cls: 'text-amber-300 border-amber-400/50 bg-amber-400/10',
    title: 'Handed to MailerLite, but NOT confirmed as delivered. It may or may not have '
         + 'arrived. This is not "sent".',
  },
  failed: {
    label: 'Failed · did not arrive',
    icon: XCircle,
    cls: 'text-red-300 border-red-400/50 bg-red-400/10',
    title: 'The campaign never left draft state. This did NOT reach them.',
  },
  campaign_not_retained: {
    label: 'Evidence gone',
    icon: FileQuestion,
    cls: 'text-purple-300 border-purple-400/50 bg-purple-400/10',
    title: 'MailerLite no longer holds this campaign, so whether it arrived can no longer '
         + 'be established. This is not a failure — it is a lost record.',
  },
  inbound: {
    label: 'They wrote',
    icon: ArrowDownLeft,
    cls: 'text-sky-300 border-sky-400/50 bg-sky-400/10',
    title: 'Inbound. They sent this to us.',
  },
  'n/a': {
    label: 'No delivery evidence',
    icon: PenLine,
    cls: 'text-hg-text-dim border-hg-border bg-transparent',
    title: 'Sent by hand, outside the Hub, or an event with no delivery to report. No '
         + 'evidence exists and none can be obtained.',
  },
};

export default function DeliveryBadge({ state, compact = false }) {
  const d = DELIVERY[state] || {
    label: String(state || 'unknown'),
    icon: HelpCircle,
    cls: 'text-hg-text-dim border-hg-border',
    title: `Unrecognised delivery state: ${state}`,
  };
  const Icon = d.icon;
  return (
    <span
      title={d.title}
      data-testid={`delivery-${state}`}
      className={`inline-flex items-center gap-1.5 rounded border px-1.5 py-0.5 text-[11px] font-medium whitespace-nowrap ${d.cls}`}
    >
      <Icon size={12} className="shrink-0" aria-hidden />
      {compact ? null : d.label}
      <span className="sr-only">{d.title}</span>
    </span>
  );
}
